import React from "react";

const Toggle = ({ value, onChange, width = "2.8em", height = "1.6em", label }) => {
  const handleToggle = (e) => {
    onChange(e);
  };

  const sliderHeight = `calc(${height} - 0.4em)`;
  const sliderWidth = `calc(${height} - 0.4em)`;

  return (
    <>
      <span className="text_wrap_nowrap">{label}</span>
      <label className="builder_toggle_label" style={{ width, height }}>
        <input type="checkbox" checked={value} onChange={handleToggle} />
        <span
          className="builder_toggle_slider"
          style={{
            height,
            width
          }}
        >
          <span
            className="slider_circle"
            style={{
              height: sliderHeight,
              width: sliderWidth
            }}
          ></span>
        </span>
      </label>
    </>
  );
};

export default Toggle;
